import Swal from 'sweetalert2';

export const confirmDelete = async (title: string = 'Are you sure?', text: string = "You won't be able to revert this!"): Promise<boolean> => {
  const result = await Swal.fire({
    title,
    text,
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#d33',
    cancelButtonColor: '#3085d6',
    confirmButtonText: 'Yes, delete it!',
    cancelButtonText: 'Cancel',
  });

  return result.isConfirmed;
};

export const confirmLogout = async (): Promise<boolean> => {
  const result = await Swal.fire({
    title: 'Are you sure?',
    text: 'You want to logout',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#d33',
    cancelButtonColor: '#3085d6',
    confirmButtonText: 'Yes, logout!',
    cancelButtonText: 'Cancel',
  });

  return result.isConfirmed;
};

export const confirmAction = async (title: string, text: string, confirmText: string = 'Yes'): Promise<boolean> => {
  const result = await Swal.fire({
    title,
    text,
    icon: 'question',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#6c757d',
    confirmButtonText: confirmText,
    cancelButtonText: 'Cancel',
  });

  return result.isConfirmed;
};
















